// module.exports = function (IndexArrayNumber) {
  //Get the sign array index number of the sign. Pass in the Month and day.;
// const signArrayId = 'A';

function signId2ArrayId(signID) {
  let signArrayId;
  //  exports.signArrayId = (signID) => {
  //  exports.signArrayId = (signID) => {
    switch (signID) {
      case "1":
          signArrayId="0";
        return signArrayId;
        // break;

      case "2":
          signArrayId="1";
        return signArrayId;
        // break;

      case "3":
          signArrayId="2";
        return signArrayId;

        // break;
      case "4":
          signArrayId="3";
        return signArrayId;

        // break;
      case "5":
          signArrayId="4";
        return signArrayId;

        // break;
      case "6":
          signArrayId="5";
        return signArrayId;

        // break;
      case "7":
          signArrayId="6";
        return signArrayId;

        // break;
      case "8":
          signArrayId="7";
        return signArrayId;

        // break;
      case "9":
          signArrayId="8";
        return signArrayId;

        // break;
      case "10":
          signArrayId="9";
        return signArrayId;

        // break;
      case "11":
          signArrayId="10";
        return signArrayId;

        // break;

      case "12":
          signArrayId="11";
        return signArrayId;

        // break;

      case 1:
          signArrayId="0";
        return signArrayId;
        // break;

      case 2:
          signArrayId="1";
        return signArrayId;
        // break;

      case 3:
          signArrayId="2";
        return signArrayId;

        // break;
      case 4:
          signArrayId="3";
        return signArrayId;

        // break;
      case 5:
          signArrayId="4";
        return signArrayId;

        // break;
      case 6:
          signArrayId="5";
        return signArrayId;

        // break;
      case 7:
          signArrayId="6";
        return signArrayId;

        // break;
      case 8:
          signArrayId="7";
        return signArrayId;

        // break;
      case 9:
          signArrayId="8";
        return signArrayId;

        // break;
      case 10:
          signArrayId="9";
        return signArrayId;

        // break;
      case 11:
          signArrayId="10";
        return signArrayId;

        // break;

      case 12:
          signArrayId="11";
        return signArrayId;

        // break;


      default:
          
        return 'undefined array ID to convery' ;
        // break;
    }
  }

  export { signId2ArrayId };
